/* S14: nach Prev/Next den tatsächlichen Scroll-Container (.page-wrapper, Horizon ab 990px)
   auf 0 fahren — window.scrollTo allein greift dort nicht. */
(function () {
  try {
    function scroller() {
      var w = document.querySelector('.page-wrapper');
      if (!w || w.scrollHeight <= w.clientHeight + 1) return null;
      var o = getComputedStyle(w).overflowY;
      return (o === 'auto' || o === 'scroll') ? w : null;
    }

    function reducedMotion() {
      try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) { return false; }
    }

    function toTop() {
      var mode = reducedMotion() ? 'instant' : 'smooth';
      var w = scroller();
      if (w) {
        try { w.scrollTo({ top: 0, behavior: mode }); } catch (e) { w.scrollTop = 0; }
      }
      try { window.scrollTo({ top: 0, behavior: mode }); } catch (e) { window.scrollTo(0, 0); }
    }

    function bind() {
      ['prevBtn', 'nextBtn'].forEach(function (id) {
        var b = document.getElementById(id);
        if (!b || b.__frtlzrToTop) return;
        b.__frtlzrToTop = 1;
        b.addEventListener('click', toTop);
      });
    }

    var _r = render;
    render = function () { _r(); bind(); };
    bind();
  } catch (e) {
    if (window.console) console.warn('FRTLZR patch S14 failed', e);
  }
})();
